import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgExclamationSmall = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx={8} cy={8} r={5.5} stroke="currentColor" />
        <line
          x1={0.75}
          y1={-0.75}
          x2={3.75}
          y2={-0.75}
          transform="matrix(-3.64262e-08 -1 -1 3.64262e-08 7.25 9.125)"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
        />
        <circle
          r={0.75}
          transform="matrix(1 0 0 -1 8 10.625)"
          fill="currentColor"
        />
      </svg>
    </IconBase>
  );
};

export default SvgExclamationSmall;
